"use client";

import React, { type ReactElement, useState } from "react";
import { twMerge } from "tailwind-merge";

import { type Context } from "@/globals";
import { type RSearchProductsType } from "@/schemes/raabits.scheme";
import { BUTTON_STYLES } from "@/styles/buttons";
import { WRAPPER_STYLES } from "@/styles/wrapper";

import { ORIENTATION, SearchItemView } from "../search-item/search-item.view";

type ProductModuleProps = {
    context: Context;
    searchResults: RSearchProductsType;
};

export const SearchModuleView = ({
    searchResults,

    context,
}: ProductModuleProps): ReactElement => {
    const [visibleCount, setVisibleCount] = useState(6);

    const loadMore = () => {
        setVisibleCount((prev) => prev + 3);
    };

    return (
        <div className={twMerge(WRAPPER_STYLES.VCenterCenter(), "gap-8")}>
            <ul className="gap-8 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3">
                {searchResults.produkte.slice(0, visibleCount).map((beitrag, i) => {
                    return (
                        <SearchItemView
                            key={i}
                            product={beitrag}
                            orientation={ORIENTATION.portrait}
                            context={context}
                        />
                    );
                })}
            </ul>
            {searchResults.produkte.length > visibleCount && (
                <button onClick={loadMore} className={BUTTON_STYLES.primaryBig()}>
                    Mehr anzeigen
                </button>
            )}
        </div>
    );
};
